import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 23 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 23.10: requires both 23.11 AND 23.12 zugmeldestelle.name content
 * - Returns true if ANY field is empty (warns if either is missing)
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl27EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag2710 = findAuftrag(befehl, '27.10')
  if (auftrag2710) {
    // Return true if field is empty
    return (
      !hasFieldContent(auftrag2710, '27.11', 'zugmeldestelle.name') ||
      !hasFieldContent(auftrag2710, '27.11', 'zugmeldestelle.art') ||
      !hasFieldContent(auftrag2710, '27.12', 'zugmeldestelle.name') ||
      !hasFieldContent(auftrag2710, '27.12', 'zugmeldestelle.art')
    )
  }

  return false
}
